import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINT } from '../../utils/Constants';

import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import dayjs from 'dayjs';
import Plotly from 'plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';
const Plot = createPlotlyComponent(Plotly);

const Graph3 = () => {
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  const [endDate, setEndDate] = React.useState<Date | null>(null);
  const [operator, setOperator] = useState([]);

  const [taskset, setTaskset] = useState([]);
  const [selectedTaskset, setSelectedTaskset] = React.useState('');
  const [selectedOperator, setSelectedOperator] = React.useState('');

  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowsTitle, setRowTitle] = useState([]);

  const layout: any = {
    title: 'タスクセット処理時間',
    barmode: 'stack',
    yaxis: {
      autorange: true,
      title: '時間 (秒)',
      titlefont: {
        size: 20,
      },
    },
    xaxis: {
      tickmode: 'array',
      tickvals: ['1:00:00', '2:00:00', '3:00:00', '4:00:00', '5:00:00', '6:00:00',
        '7:00:00', '8:00:00', '9:00:00', '10:00:00', '11:00:00', '12:00:00',
        '13:00:00', '14:00:00', '15:00:00', '16:00:00', '17:00:00', '18:00:00',
        '19:00:00', '20:00:00', '21:00:00', '22:00:00', '23:00:00', '24:00:00',],
      ticktext: [ '１時', '２時', '３時', '４時', '５時', '６時',
        '７時', '８時', '９時', '１０時', '１１時', '１２時',
        '１３時', '１４時', '１５時', '１６時', '１７時', '１８時',
        '１９時', '２０時', '２１時', '２２時', '２３時', '２４時',]
    }
  };

  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectedTaskset(event.target.value as string);
  };

  const handleChange2 = (event: SelectChangeEvent) => {
    setSelectedOperator(event.target.value as string);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      axios
        .post(API_ENDPOINT + 'graph3', {
          startDate,
          endDate,
          selectedTaskset,
          selectedOperator,
        })
        .then((res) => {
          const data = res.data.data;
          setData(res.data.data);

          // table data
          const rw = [];
          const dateList = [];
          for (let i= 0; i < data.length; i++){
            for (let k= 0; k < data[i].time.length; k++){
              if (dateList.indexOf(data[i].time[k]) === -1){
                dateList.push(data[i].time[k]);
              }
            }
          }
          for (let k= 0; k < dateList.length; k++){
            rw.push({'date': dateList[k], 'data': []});
            for (let i= 0; i < data.length; i++){
              for (let m= 0; m < data[i].time.length; m++){
                if (rw[k].date === data[i].time[m]){
                  rw[k].data.push({'task': data[i].task, 'time': data[i].time[m], 'duration': data[i].duration[m]});
                }
              }
            }
          }
          rw.sort((x,y) => {
            const x_date = parseInt(x.date.substring(0,x.date.length-6));
            const y_date = parseInt(y.date.substring(0,x.date.length-6));
            return x_date - y_date;
          });

          setRows(rw);
          setRowTitle([{'tasksetName': selectedTaskset.split(':')[1], 'operatorName': selectedOperator.split(':')[1]}]);
        
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };


  // -----------------
  const defaultTraces = useCallback((defaulTaskset, defaultOperator ) => {
    axios.post(API_ENDPOINT + 'graph3', {
      'startDate': dayjs().subtract(1, 'd'),
      'endDate': dayjs(),
      'selectedTaskset': defaulTaskset,
      'selectedOperator': defaultOperator
    })
      .then((res) => {
        const data = res.data.data;
        setData(res.data.data);

        // table data
        const rw = [];
        const dateList = [];
        for (let i= 0; i < data.length; i++){
          for (let k= 0; k < data[i].time.length; k++){
            if (dateList.indexOf(data[i].time[k]) === -1){
              dateList.push(data[i].time[k]);
            }
          }
        }
        for (let k= 0; k < dateList.length; k++){
          rw.push({'date': dateList[k], 'data': []});
          for (let i= 0; i < data.length; i++){
            for (let m= 0; m < data[i].time.length; m++){
              if (rw[k].date === data[i].time[m]){
                rw[k].data.push({'task': data[i].task, 'time': data[i].time[m], 'duration': data[i].duration[m]});
              }
            }
          }
        }
        rw.sort((x,y) => {
          const x_date = parseInt(x.date.substring(0,x.date.length-6));
          const y_date = parseInt(y.date.substring(0,x.date.length-6));
          return x_date - y_date;
        });

        setRows(rw);
        setRowTitle([{'tasksetName': defaulTaskset.split(':')[1], 'operatorName': defaultOperator.split(':')[1]}]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getStatus = useCallback(() => {
    axios
      .get(API_ENDPOINT + 'graph3')
      .then((res) => {
        setTaskset(res.data.data[0]);
        setOperator(res.data.data[1]);
        defaultTraces(
          res.data.data[0][0][0] + ':' + res.data.data[0][0][1],
          res.data.data[1][0][0] + ':' + res.data.data[1][0][1]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [defaultTraces]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  const traces: any = [];
  const rows2 = [];
  function createData2(task: string, duration: string, time: string) {
    return { task, duration, time };
  }
  Object.keys(data).forEach(function (key) {
    rows2.push(
      createData2(
        data[key].task,
        data[key].duration.join(','),
        data[key].time.join(',')
      )
    );
    const trace = {
      x: data[key].time,
      y: data[key].duration,
      name: data[key].task,
      hovertemplate: '<b>%{y}秒</b>',
      type: 'bar',
    };
    traces.push(trace);
  });



  return (
    <Stack spacing={2}>
      <Stack direction='row' spacing={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <FormControl fullWidth>
            <DatePicker
              label='Start Date'
              value={startDate}
              onChange={(newValue) => {
                setStartDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
          <FormControl fullWidth>
            <DatePicker
              label='End Date'
              value={endDate}
              onChange={(newValue) => {
                setEndDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </LocalizationProvider>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>
            実行タスクセット
          </InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedTaskset}
            label='task set'
            onChange={handleChange1}
          >
            {taskset.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>
            オペレーター選択
          </InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedOperator}
            label='Operator'
            onChange={handleChange2}
          >
            {operator.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button onClick={handleSubmit} variant='contained'>
          検索
        </Button>
      </Stack>
      <Plot data={traces} layout={layout} config={{'displayModeBar': false}} />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>オペレーター</TableCell>
              <TableCell>タスクセット</TableCell>
              <TableCell>時間帯</TableCell>
              <TableCell>継続時間(秒)</TableCell>
              <TableCell>タスク名</TableCell>
              <TableCell>継続時間(秒)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsTitle.map((item) => {
              let operatorrowSpanNum = 1 + 2 * rows.length;
              for (let i= 0; i < rows.length; i++){
                operatorrowSpanNum += rows[i].data.length + 1;
              }
              return (
                <>
                  <TableRow key={item.operatorName}>
                    <TableCell rowSpan={operatorrowSpanNum}>{item.operatorName}</TableCell>
                    <TableCell rowSpan={operatorrowSpanNum}>{item.tasksetName}</TableCell>
                  </TableRow>
                  {rows.map((task) => {
                    const rowSpanNum = 1 + task.data.length;
                    let tasksetTimeSUM = 0;
                    for(let i = 0; i < task.data.length; i++){
                      tasksetTimeSUM += parseInt(task.data[i].duration);
                    }
                    return (
                      <>
                        <TableRow key={task.date}>
                          <TableCell rowSpan={rowSpanNum}>{task.date.substring(0,task.date.length-6)}時</TableCell>
                          <TableCell rowSpan={rowSpanNum}>{tasksetTimeSUM}秒</TableCell>
                        </TableRow>
                        {task.data.map((data) => {
                          return (
                            <TableRow key={data.task+task.date}>
                              <TableCell>{data.task}</TableCell>
                              <TableCell>{data.duration}秒</TableCell>
                            </TableRow>
                          );
                        })} 
                      </>
                    );
                  })}  
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
    </Stack>
  );
};

export default Graph3;
